import React from 'react';
import { Card, Skeleton, Progress } from 'antd';
import { IntentDistributionItem } from '../../services/dashboardService';

interface IntentDistributionProps {
    data: IntentDistributionItem[];
    loading?: boolean;
}

const IntentDistribution: React.FC<IntentDistributionProps> = ({ data, loading }) => {
    return (
        <Card
            title={<span style={{ fontWeight: 600 }}>意图分布</span>}
            variant="borderless"
            style={{ borderRadius: 12, height: '100%', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' }}
        >
            <Skeleton loading={loading} active paragraph={{ rows: 5 }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                    {data && data.length > 0 ? (
                        data.map((item, index) => (
                            <div key={index} style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                <span style={{ width: 80, fontSize: 14, color: '#3F3F46', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                    {item.name}
                                </span>
                                <div style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
                                    <Progress
                                        percent={item.value}
                                        strokeColor={item.color}
                                        showInfo={false}
                                        size="small"
                                        style={{ margin: 0 }}
                                    />
                                </div>
                                <span style={{ width: 40, textAlign: 'right', fontSize: 14, fontWeight: 500, color: '#18181B' }}>
                                    {item.value}%
                                </span>
                            </div>
                        ))
                    ) : (
                        <div style={{ textAlign: 'center', color: '#A1A1AA', padding: '20px 0' }}>暂无数据</div>
                    )}
                </div>
            </Skeleton>
        </Card>
    );
};

export default IntentDistribution;
